import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";

export const DealerAccountColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setAccountId,
  setShowAccountModal
) => {
  return [
    // {
    //   title: "No",
    //   dataIndex: "AccountNo",
    //   key: "AccountNo",
    //   onHeaderCell: () => ({ onClick: () => {} }),
    //   //   sorter: (a, b) => () => {},
    //   //   sortIcon: () => (
    //   //     <SortIcon
    //   //       sortOrder={modParams.order}
    //   //       columnKey="ProductionNo"
    //   //       sortBy={modParams.sort_by}
    //   //     />
    //   //   ),
    //   //   onHeaderCell: () => ({
    //   //     onClick: () =>
    //   //       setParams((prev) => ({
    //   //         ...modParams,
    //   //         sort_by: "ProductionNo",
    //   //         order: modParams.order === "desc" ? "asc" : "desc",
    //   //       })),
    //   //   }),
    // },

    {
      title: "Username",
      dataIndex: "UserId",
      key: "UserId",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionDesc"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionDesc",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Description",
      dataIndex: "AccountDesc",
      key: "AccountDesc",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Account Type",
      dataIndex: "AccountType",
      key: "AccountType",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionTime"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionTime",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },

    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAccountModal(true);
                    setAccountId(record?.AccountNo);
                  }}
                  className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 "
                >
                  <div className=" hover:text-[#636262ee]">
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </div>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.AccountNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
